import { useEffect, useRef } from 'react';
export var useTimeout = function (callback, delay) {
    var savedCallback = useRef();
    useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(function () {
        var tick = function () { var _a; return (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback); };
        var timerId = window.setTimeout(tick, delay);
        return function () { return clearTimeout(timerId); };
    }, [delay]);
};
